import {useEffect, useMemo} from "react";
import {useSelector} from "react-redux";
import type {RootState} from "../../../redux/store";
import {bildirimTercihiAyarla, bildirimTercihiCoz, bildirimYerlesimi} from "./bildirimTercihi";
import {configureNotifier} from "./notifier";

/** `state.theme.gorunum` içindeki bir alan (alanı tip tanımında henüz yoksa da derlenir) */
export const gorunumAlani = <T, >(s: RootState, ad: string): T | undefined =>
    (s.theme?.gorunum as unknown as Record<string, unknown> | undefined)?.[ad] as T | undefined;

/**
 * Görünüm › Bildirimler tercihini bildirim yardımcılarına aktarır (MinoNotificationProvider'da bir kez çağrılır).
 * Bildirim göstermek modül işlevleriyle (notify / SendNotification) yapıldığı için tercih modül durumunda tutulur.
 */
export const useBildirimTercihi = (): void => {
    const ham = useSelector((s: RootState) => gorunumAlani<unknown>(s, "bildirim"));
    const anahtar = JSON.stringify(ham ?? null);
    const tercih = useMemo(() => bildirimTercihiCoz(ham), [anahtar]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        bildirimTercihiAyarla(tercih);
        configureNotifier({placement: bildirimYerlesimi()});
    }, [tercih]);
};
